export const getFallbackURL = () => {
  const activeOrgId = window.localStorage.getItem('active-org-id');

  if (!activeOrgId) {
    return '/';
  }

  return `/${activeOrgId}/auth/sign-in`;
};
